import _ from 'lodash';

function EntryListCtrl($rootScope, $scope, $state, $stateParams, $timeout, toastr, PlanService, PlayerService, AuthService, UserService, AppContextService, data) {
  'ngInject';

  var vm = this;

  vm.appContext = AppContextService.context;
  vm.appContext.selectedPlayer = null;
  vm.team_code = data.team_code;

  // 선수로 로그인하였을 경우
  if (vm.appContext.role2 === 'player') {
    vm.appContext.selectedPlayer = vm.appContext.user;
  }

  if (vm.appContext.role2 === 'sa21c' && !$stateParams.manager_admin_team_id) {
    vm.appContext.players.all = [];
    return;
  }

  vm.playerPositionClass = ['FW-LWF', 'FW-ST', 'FW-RWF', 'MF-LWM', 'MF-CAM', 'MF-RWM', 'MF-LM', 'MF-CM', 'MF-RM', 'MF-CDM', 'DF-LWB', 'DF-RWB', 'DF-LB', 'DF-CB', 'DF-RB', 'GK'];

  vm.appContext.my_team = {
    team_id: null
  }

  vm.appContext.oppo_team = {
    team_id: null
  }

  vm.stateName = $state.current.name;

  var d = new Date();
  var y = d.getFullYear();
  vm.appContext.user.age = y - Number(vm.appContext.user.birth_date.substring(0, 4));

  var data = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    [$stateParams.type_code + '_id']: $stateParams.id,
  };

  PlanService.getGameInfo(data)
    .then(function (res) {
      if (vm.team_code === 'oppo_team') {
        vm.team_id = res.data.team_id;
        vm.team_name = res.data.team_name;
        vm.country_name = res.data.country_name;
        // vm.appContext.oppo_team.team_id = res.data.team_id;

        vm.appContext.oppo_team.team_id = vm.team_id;
        vm.appContext.oppo_team.team_name = vm.team_name;
        vm.appContext.oppo_team.country_name = vm.country_name;
      } else {
        // alert('aaa');
        vm.team_id = vm.appContext.info.team_id;
        vm.team_name = vm.appContext.info.team_name;
        vm.country_name = vm.appContext.info.country_name;

        vm.appContext.my_team.team_id = vm.team_id;
        vm.appContext.my_team.team_name = vm.team_name;
        vm.appContext.my_team.country_name = vm.country_name;

        // 전체관리자가 선택한 team_id
        if ($stateParams.manager_admin_team_id) {
          vm.appContext.my_team = vm.appContext.manager_admin_team;
        }
        // 팬이 선택한 user_id
        else if ($stateParams.fan_user_id) {
          UserService.info({
            'user_id': $stateParams.fan_user_id
          }).then(function (res) {
            PlayerService.getPlayerBiometricInfo({
              'user_id': $stateParams.fan_user_id
            }).then(function (res2) {
              vm.appContext.fanSelectedPlayer = angular.merge({}, res2.data, res.data);
            }).catch(function (error) {
              console.log("An error occured : " + error);
            });
          }).catch(function (error) {
            console.log("An error occured : " + error);
          });

          UserService.teamInfo({id: $stateParams.fan_user_team_id}).then(function(res2) {
            vm.appContext.my_team = {
              team_id: vm.appContext.info.team_id,
              team_name: vm.appContext.info.team_name,
              country_name: vm.appContext.info.country_name,
              parent_team_name: res2.data.name
            };
          }).catch(function (e) {
            console.log('ERROR ' + e);
          });
        }
        // 팬이 선택한 team_id
        else if ($stateParams.fan_team_id) {
          UserService.teamInfo({id: $stateParams.fan_team_id}).then(function(res2) {
            vm.appContext.my_team = {
              team_id: $stateParams.fan_team_id,
              team_name: res2.data.name,
              country_name: res2.data.country_name
            };
          }).catch(function (error) {
            console.log("An error occured : " + error);
          });
        }
        // 감독-선수 소속팀 관련 수정
        // 감독-선수가 선택한 team_id
        else if ($stateParams.coach_player_team_id) {
          UserService.teamInfo({id: $stateParams.coach_player_team_id}).then(function(res2) {
            vm.appContext.my_team = {
              team_id: $stateParams.coach_player_team_id,
              team_name: res2.data.name,
              country_name: res2.data.country_name
            };
          }).catch(function (error) {
            console.log("An error occured : " + error);
          });
        }
        else {
          // 좌측 상단에 팀명 표시를 위해서
          UserService.teamInfo({id: vm.appContext.info.parent_team_id}).then(function(res2) {
            vm.appContext.my_team.parent_team_name = res2.data.name;
          }).catch(function (error) {
            console.log("An error occured : " + error);
          });
        }
      }
    })
    .catch(function (error) {
      console.log("An error occured : " + error);
    });

  _.map(vm.appContext.players.all, function (x) {
    if (vm.appContext.role2 === 'player') {
      x.selected = true;
    } else {
      x.selected = false;
    }
    return x
  });

  vm.clearOtherPlayerSelection = function(both) {

    // console.log('both....', both)
    // console.log('clearOtherTeamSelection');
    // console.log(vm.appContext);
    // console.log(vm.team_code);
    // if (vm.team_code === 'my_team') {
    // }

    var team = vm.team_code === 'my_team' ? 'oppo_team' : 'my_team';
    if (!vm.appContext.players.game[team].entryMain) {
      return;
    }
    vm.appContext.players.game[team].entryMain.map(function (x) {
      x.selected = false;
      return x
    });
    vm.appContext.players.game[team].entryBackup.map(function (x) {
      x.selected = false;
      return x
    });

    if (both) {
      // console.log('both......');
      // team = team === 'my_team' ? 'oppo_team' : 'my_team';
      team = vm.team_code === 'my_team' ? 'my_team' : 'oppo_team';

      vm.appContext.players.game[team].entryMain.map(function (x) {
        x.selected = false;
        return x
      });
      vm.appContext.players.game[team].entryBackup.map(function (x) {
        x.selected = false;
        return x
      });

    }


  }



  var setDisplayPosition = function () {

    vm.positions = [];

    _.forEach(vm.playerPositionClass, function (position) {
      vm.positions.push({
        position_name: position,
        players: []
      })
    })
    _.forEach(vm.appContext.players.game[vm.team_code].entryMain, function (player) {
      (_.find(vm.positions, {
        position_name: player.position_name
      })).players.push(player);
    });
    vm.appContext.players.game[vm.team_code].positionPlayers = _.uniqBy(vm.appContext.players.game[vm.team_code].entryMain, 'position_name');

  };

  var getEntry2 = function () {
    
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
    }

    if ($stateParams.type_code === 'game') {
      data.game_id = $stateParams.id;
      data.status = 'IN';
      data.is_oppo = $stateParams.team_code == 'oppo_team' ? 'Y' : 'N';
      PlanService.getEntry(data)
        .then(function (res) {
          vm.appContext.players.game.my_team.entryMain = res.data.players;

          // $scope.$emit('game.my_team.entryMain', res.data.players);
          // console.log('vm.team_code', vm.team_code);
          $scope.$emit('game.my_team.entryMain', res.data.players);

          setDisplayPosition();

          data.status = 'WAIT';
          data.is_oppo = 'N';
          return PlanService.getEntry(data);
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        })
        .then(function (res) {
          vm.appContext.players.game.my_team.entryBackup = res.data.players;
          data.status = 'IN';
          data.is_oppo = 'Y';
          return PlanService.getEntry(data);
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        })
        .then(function (res) {
          vm.appContext.players.game.oppo_team.entryMain = res.data.players;
          // $scope.$emit('game.oppo_team.entryMain', res.data.players);

          setDisplayPosition();

          data.status = 'WAIT';
          data.is_oppo = 'Y';
          return PlanService.getEntry(data);
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        })
        .then(function (res) {
          vm.appContext.players.game.oppo_team.entryBackup = res.data.players;
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        });
    }

    if ($stateParams.type_code === 'training') {
      data.training_root_id = $stateParams.id;
      PlanService.getTrainingEntry(data)
        .then(function (res) {
          vm.appContext.players.training.my_team.entryMain = res.data.players;
          return PlanService.getEntry(data);
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        });
    }

  };

  var getEntry = function () {
    // console.log('getEntry', $stateParams.type_code, vm.team_code);

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
    }

    if ($stateParams.type_code === 'game') {
      data.game_id = $stateParams.id;
      data.status = 'IN';
      data.is_oppo = vm.team_code == 'oppo_team' ? 'Y' : 'N';
      // console.log('data', data)
      PlanService.getEntry(data)
        .then(function (res) {
          vm.appContext.players[$stateParams.type_code][vm.team_code].entryMain = res.data.players;
          // $scope.$emit('game.my_team.entryMain', res.data.players);

          setDisplayPosition();
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        });


      data.status = 'WAIT';
      // console.log('data', data)

      PlanService.getEntry(data)
      .then(function(res) {
        vm.appContext.players[$stateParams.type_code][vm.team_code].entryBackup = res.data.players;
        // $scope.$emit('game.my_team.entryBackup', res.data.players);

      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
    }

    if ($stateParams.type_code === 'training') {
      data.training_root_id = $stateParams.id;
      PlanService.getTrainingEntry(data)
        .then(function (res) {
          vm.appContext.players.training.my_team.entryMain = res.data.players;
          // return PlanService.getEntry(data);
        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        });
    }

  };

  getEntry();

  vm.showNoOtherTeamMeassage = function() {
    toastr.error('먼저 경기정보에서 상대팀을 선택하고 경기저장 버튼을 클릭해주세요');
  };

  // view 가 load 된 이후에 실행
  $scope.$on('$viewContentLoaded', function(){
    if (vm.appContext.isMobile) {
      $('body').off('click.entry-list');
      $('body').on('click.entry-list', function(e) {
        if ($(e.target).hasClass('entry-list-dropdownbtn')) {
          return;
        }
        $('.entry-list-dropdownmenu').removeClass('w3-show');
      });
    }
  });

}

export default {
  name: 'EntryListCtrl',
  fn: EntryListCtrl
};
